import {createAction, createReducer} from 'redux-act'
import { translatedConfigSelector as configSelector } from '~/config'
import { select, apply, put, takeEvery } from 'redux-saga/effects'
import { get } from 'lodash'
import { all } from 'redux-saga/effects'
import { Entity, handleError } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'shopPaymentMethod';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  paymentMethodAction: {
    request: createAction('payment method action request', (actionUrl, params) => ({actionUrl, params})),
    failure: createAction('payment method action failure', (message) => ({message})),
    success: createAction('payment method action success', (data) => ({data}))
  },
};

export const TYPE_SHOP_MAKSEKESKUS = 'ShopMaksekeskusMethod';
export const TYPE_SHOP_PAYPAL = 'ShopPaypalMethod';
export const TYPE_SHOP_STRIPE = 'ShopStripeMethod';
export const TYPE_SHOP_BANK_DEPOSIT = 'ShopBankDepositMethod';
export const TYPE_SHOP_PAYSERA = 'ShopPayseraMethod';
export const TYPE_SHOP_MONTONIO = 'ShopMontonioMethod';

export const TYPE_ROUTES = {
  'BankDepositMethod': 'shop-bank-deposit',
  'MaksekeskusMethod': 'shop-maksekeskus',
  'PaypalMethod': 'shop-paypal',
  'PayseraMethod': 'shop-paysera',
  'StripeMethod': 'shop-stripe',
  'MontonioMethod': 'shop-montonio',
  [TYPE_SHOP_BANK_DEPOSIT]: 'shop-bank-deposit',
  [TYPE_SHOP_MAKSEKESKUS]: 'shop-maksekeskus',
  [TYPE_SHOP_PAYPAL]: 'shop-paypal',
  [TYPE_SHOP_PAYSERA]: 'shop-paysera',
  [TYPE_SHOP_STRIPE]: 'shop-stripe',
  [TYPE_SHOP_MONTONIO]: 'shop-montonio',
};

// WORKERS
export const workers = {
  ...entity.workers,
  * createShopPaymentMethod(action) {
    const { route, data } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const response = yield apply(api, api.callRoute, [`${route}/`, 'POST', data]);

      yield put(actions.create.success(response.data));

      return response.data;
    } catch (e) {
      handleError(e, actions.create);
      throw e;
    }
  },
  * paymentMethodAction(action) {
    const { actionUrl, params } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const response = yield apply(api, api.call, [actionUrl, 'GET', null, params]);

      yield put(actions.paymentMethodAction.success(response.data));

      return response.data;
    } catch (e) {
      handleError(e, actions.paymentMethodAction);
      throw e;
    }
  },
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.paymentMethodAction.request().type, workers.paymentMethodAction)

  ]);
}

export const reducer = createReducer(entity.reducer, {});

export default {
  actions,
  workers,
  saga,
  reducer
}
